import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const TeamManagementDetail = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
        };
    }, []);


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Teams Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Team A</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/team-management"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="text-end" style={{ marginTop: '-70px', marginBottom: '30px' }}>
                        <Link to="/add-player" style={{ width: 'fit-content' }}
                            className="d-flex align-items-center btn btn-primary font-18 ms-auto">
                            <i className="bx bx-plus ms-1" /> <span>Add New Player </span>
                        </Link>
                    </div>
                    <div className="profile_modal_wrap">
                        <div className="main-body">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="modaldetails" role="tabpanel">
                                    <div className="card personal_d">
                                        <div className="card-body">
                                            <h2>Team Details</h2>
                                            <div className="row">
                                                <div className="col-lg-2">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <img src="images/team/tb.jpg" alt="Admin" className="p-1 bg-primary" style={{ width: 170, height: 170, objectFit: 'cover', borderRadius: '50%' }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp">
                                                        <label>Name</label>
                                                        <input type="text" className="form-control" defaultValue="Team A" readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Match Count</label>
                                                        <input type="text" className="form-control" defaultValue={156} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="inp_grp">
                                                        <label>Player Count</label>
                                                        <input type="text" className="form-control" defaultValue={11} readOnly />
                                                    </div>
                                                    <div className="inp_grp">
                                                        <label>Country</label>
                                                        <input type="text" className="form-control" defaultValue="USA" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="inp_grp">
                                                        <label>Age Group</label>
                                                        <input type="text" className="form-control" defaultValue="U-18" readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card personal_d">
                                        <div className="card-body">
                                            <h2>Coach Details</h2>
                                            <div className="row align-items-center">
                                                <div className="col-lg-1">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <img src="images/avatars/avatar-1.png" alt="Admin" className="bg-primary" width={85} style={{ borderRadius: 100, width: 100, height: 100, padding: 2 }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp m-0">
                                                        <label>Name</label>
                                                        <input type="text" className="form-control" defaultValue="Coach James" readOnly />
                                                        <Link to="/coach-detail" className="view_uprof">View Profile</Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="inp_grp m-0">
                                                        <label>Email Address</label>
                                                        <input type="text" className="form-control" defaultValue="James@gmail.com" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="inp_grp m-0">
                                                        <label>Experience</label>
                                                        <input type="text" className="form-control" defaultValue="Expert" readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card personal_d">
                                        <div className="card-body">
                                            <h4 className="heading_rec">Team Players</h4>
                                            <div className="table-responsive">
                                                <div className="entries-wrapper mb-3">
                                                    <label className="entries-label">
                                                        <span>Showing</span>
                                                        <select className="entries-select">
                                                            <option value={10} selected>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                        <span>Entries</span>
                                                    </label>
                                                </div>
                                                <table ref={table1} className="table table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Position</th>
                                                            <th>Jersey</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Player One</td>
                                                            <td>Forward</td>
                                                            <td>#10</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                                    <li>
                                                                        <Link to="/team-player-detail">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Player Two</td>
                                                            <td>Midfielder</td>
                                                            <td>#8</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                                    <li>
                                                                        <Link to="/team-player-detail">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Player Three</td>
                                                            <td>Defender</td>
                                                            <td>#4</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                                    <li>
                                                                        <Link to="/team-player-detail">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Player Four</td>
                                                            <td>Goalkeeper</td>
                                                            <td>#1</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                                    <li>
                                                                        <Link to="/team-player-detail">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal">
                                                                            <i data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this player?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default TeamManagementDetail